import { h } from '../utils/dom';
import { getWhatsAppIcon } from './mark';

export function createHandoffCard(waUrl: string, message: string | null): HTMLDivElement {
  const card = h('div', { class: 'att-handoff-card' }) as HTMLDivElement;

  const header = h('div', { class: 'att-handoff-card-header' });
  header.innerHTML = getWhatsAppIcon(20);
  header.appendChild(document.createTextNode(' Continuar no WhatsApp'));
  card.appendChild(header);

  if (message) {
    const msg = h('p', { class: 'att-handoff-card-msg' }, message);
    card.appendChild(msg);
  }

  const btn = h('a', {
    class: 'att-handoff-btn',
    href: waUrl,
    target: '_blank',
    rel: 'noopener noreferrer',
  }) as HTMLAnchorElement;
  btn.innerHTML = getWhatsAppIcon(18);
  btn.appendChild(document.createTextNode(' Abrir WhatsApp'));
  card.appendChild(btn);

  return card;
}
